import { useEffect, useRef } from 'react';
import {
  useConfigurationStore,
  useStatusBuilderConfiguration,
} from '../../../shared/stores/useConfigurationStore';
import {
  areStatusCategoriesEqual,
  reconcileProjectPhaseStatusCategories,
  removeGeneratedProjectPhaseStatusCategories,
} from '../lib/projectPhaseStatusCategories';
import { useProjectPhaseOptions } from './useProjectPhaseOptions';

export function useProjectPhaseStatusCategories() {
  const phaseState = useProjectPhaseOptions();
  const { categories } = useStatusBuilderConfiguration();
  const setStatusBuilderConfiguration = useConfigurationStore(
    (state) => state.setStatusBuilderConfiguration,
  );
  const previousScopeKey = useRef(phaseState.scopeKey);

  useEffect(() => {
    const scopeChanged = previousScopeKey.current !== phaseState.scopeKey;
    previousScopeKey.current = phaseState.scopeKey;

    if (!phaseState.scopeKey || !phaseState.isRuntimeAvailable) {
      return;
    }

    const nextCategories = scopeChanged || phaseState.isLoading
      ? removeGeneratedProjectPhaseStatusCategories(categories)
      : reconcileProjectPhaseStatusCategories(categories, phaseState.phaseNames);

    if (!areStatusCategoriesEqual(nextCategories, categories)) {
      setStatusBuilderConfiguration({ categories: nextCategories });
    }
  }, [
    categories,
    phaseState.isLoading,
    phaseState.isRuntimeAvailable,
    phaseState.phaseNames,
    phaseState.scopeKey,
    setStatusBuilderConfiguration,
  ]);

  return phaseState;
}
